export default {
    data() {
        return {
            basePath: global.BasePath,
            pagination: {
                pageSize: 10,
                pages: 0,
                total: 0,
                pageNo: 1,
            }
        }
    },
    filters: {
        timeSuffixFilter(datetime) {
            return datetime ? datetime.slice(0, datetime.indexOf('.')) : datetime;
        }
    },
    methods: {
        jumpToPage(path, query = {}, isReplace = false, isRefresh = false, refreshTimeout = 300) {
            if(isReplace) {
                this.$router.replace({
                    path,
                    query
                })
            } else {
                this.$router.push({
                    path,
                    query
                })
            }
            if(isRefresh) {
                setTimeout(() => {
                    window.location.reload();
                }, refreshTimeout);
            }
        },
        changeSize(pageSize) {
            this.pagination.pageNo = 1;
            this.pagination.pageSize = pageSize;
        },
        changeCurrent(pageNo) {
            this.pagination.pageNo = pageNo;
        },
        checkIndexPermission(permissionList, permissionPath) {
            return permissionList.indexOf(permissionPath) !== -1;
        },
        divide(arg1, arg2, precision = 0) {
            let result = arg1 / arg2;
            const multiplier = 10 ** precision;
            return Math.round(result * multiplier) / multiplier;
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/baseMixin.js